import React from 'react';

import type { SliderProps } from '@mui/material/Slider';
import MuiSlider from '@mui/material/Slider';

import { styledComponent } from 'src/utils/styled';

export interface Props extends SliderProps {
    readOnly?: boolean;
}
const StyledSlider = styledComponent(MuiSlider)`
    ${(props: Props) =>
        props.readOnly &&
        `
        pointer-events: none;
    `}
`;
const Slider: React.FC<Props> = (props) => <StyledSlider {...props} />;
export default Slider;
